module.exports = __webpack_public_path__ + "static/media/detasad-D-icon.33c2d436.svg";